import { put, call, takeLatest } from 'redux-saga/effects';
import { getReferralInfo } from '~/common/redux/api';
import * as actions from '../actions';
import { GET_REFERRAL_INFO_REQUEST } from '../types';

export function* getReferralInfoSaga() {
  try {
    yield put(actions.addLoader(GET_REFERRAL_INFO_REQUEST));
    const {
      data: { data, success },
    } = yield call(getReferralInfo);

    if (!success) {
      yield put(actions.getReferralInfoFailure());
    } else {
      yield put(actions.getReferralInfoSuccess(data));
    }
  } catch (e) {
    yield put(actions.getReferralInfoFailure());
  }
  yield put(actions.removeLoader(GET_REFERRAL_INFO_REQUEST));
}

const referralInfoSaga = [takeLatest(GET_REFERRAL_INFO_REQUEST, getReferralInfoSaga)];

export default referralInfoSaga;
